/* HOTSTOP B90G — CART BUBBLE SYNC FIX */
/* HOTSTOP B90F — FAST CART + PARENT-LINKED FREE MODIFIERS */
/* HOTSTOP B90E — FAST CART + FREE MODIFIERS AS LINE ITEMS */
/* HOTSTOP B90D — CART BADGE STABILITY + FREE MODIFIER VISIBILITY */
/* HOTSTOP B90C — CART LOGIC RELIABILITY + UI SYNC */
/* HOTSTOP B90B — CUSTOMIZE YOUR ORDER TOGGLE */
/*
  HOTSTOP B90A/B90B — CUSTOM ORDER BUILDER MODAL
  Fresh custom restaurant-order modal. It opens from HS Orbital Hero product cards
  and does not depend on Horizon's native quick-add modal internals.
*/

(() => {
  if (window.HotStopOrderBuilder) return;

  const STATE_OPEN = 'is-open';
  const STATE_CLOSING = 'is-closing';
  const BODY_LOCK = 'hotstop-order-builder-open';

  let modal = null;
  let currentProduct = null;
  let selectedAddons = new Set();
  let closeTimer = null;

  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

  function parseJson(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.warn('[HotStop B90A] Invalid order builder product JSON.', error);
      return null;
    }
  }

  function findProductScript(root, productId) {
    const id = String(productId || '');
    if (!id) return null;

    const safeSelector = CSS.escape(id);
    return (
      root?.querySelector?.(`script[data-hotstop-order-builder-product][data-product-id="${safeSelector}"]`) ||
      document.querySelector(`script[data-hotstop-order-builder-product][data-product-id="${safeSelector}"]`)
    );
  }

  function openFromHero(hero, productId) {
    if (!isDesktop()) return false;

    const script = findProductScript(hero, productId);
    const product = parseJson(script);

    if (!product || !product.variantId) {
      document.documentElement.dataset.hotstopB90aStatus = 'missing-product-json';
      return false;
    }

    open(product);
    return true;
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'hotstop-order-builder';
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="hotstop-order-builder__backdrop" data-hotstop-ob-close></div>
      <div class="hotstop-order-builder__dialog" role="dialog" aria-modal="true" aria-labelledby="hotstop-ob-title">
        <button class="hotstop-order-builder__close" type="button" aria-label="Close order builder" data-hotstop-ob-close>
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>

        <div class="hotstop-order-builder__media">
          <img class="hotstop-order-builder__image" data-hotstop-ob-image alt="">
        </div>

        <div class="hotstop-order-builder__content">
          <div class="hotstop-order-builder__scroll">
            <header class="hotstop-order-builder__header">
              <h2 class="hotstop-order-builder__title" id="hotstop-ob-title" data-hotstop-ob-title></h2>
              <p class="hotstop-order-builder__price" data-hotstop-ob-price></p>
              <p class="hotstop-order-builder__description" data-hotstop-ob-description></p>
            </header>

            <section class="hotstop-order-builder__customize" data-hotstop-ob-customize hidden>
              <label class="hotstop-ob-toggle">
                <span class="hotstop-ob-toggle__copy">
                  <span class="hotstop-ob-toggle__title">Make it your own</span>
                  <span class="hotstop-ob-toggle__sub">Customize your order with tasty extras</span>
                </span>
                <input type="checkbox" data-hotstop-ob-customize-toggle aria-label="Customize your order">
                <span class="hotstop-ob-toggle__switch" aria-hidden="true"></span>
              </label>
            </section>

            <section class="hotstop-order-builder__addons" data-hotstop-ob-addons hidden>
              <div class="hotstop-order-builder__addons-head">
                <div>
                  <h3 class="hotstop-order-builder__addons-title">Tasty Add-ons</h3>
                  <p class="hotstop-order-builder__addons-sub">Choose tasty extras for this meal</p>
                </div>
                <span class="hotstop-order-builder__count" data-hotstop-ob-addon-count>0</span>
              </div>
              <div class="hotstop-order-builder__addons-grid" data-hotstop-ob-addon-grid></div>
            </section>
          </div>

          <footer class="hotstop-order-builder__footer">
            <div class="hotstop-order-builder__quantity-row">
              <div>
                <p class="hotstop-order-builder__total-label">Total preview</p>
                <p class="hotstop-order-builder__total" data-hotstop-ob-total></p>
              </div>

              <div class="hotstop-ob-qty">
                <button type="button" data-hotstop-ob-qty-minus aria-label="Reduce quantity">−</button>
                <input type="number" min="1" step="1" value="1" inputmode="numeric" aria-label="Quantity" data-hotstop-ob-qty>
                <button type="button" data-hotstop-ob-qty-plus aria-label="Increase quantity">+</button>
              </div>
            </div>

            <button class="hotstop-order-builder__button" type="button" data-hotstop-ob-submit>
              Add to cart
            </button>
            <p class="hotstop-order-builder__message" data-hotstop-ob-message></p>
          </footer>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    bindModal();
    return modal;
  }

  function bindModal() {
    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-hotstop-ob-close]')) {
        event.preventDefault();
        close();
        return;
      }

      const addon = event.target.closest('[data-hotstop-ob-addon]');
      if (addon && modal.contains(addon)) {
        event.preventDefault();
        toggleAddon(addon.dataset.index);
      }
    });

    modal.addEventListener('keydown', (event) => {
      const addon = event.target.closest('[data-hotstop-ob-addon]');
      if (addon && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        toggleAddon(addon.dataset.index);
      }
    });

    modal.querySelector('[data-hotstop-ob-qty-minus]').addEventListener('click', () => {
      setQuantity(getQuantity() - 1);
    });

    modal.querySelector('[data-hotstop-ob-qty-plus]').addEventListener('click', () => {
      setQuantity(getQuantity() + 1);
    });

    modal.querySelector('[data-hotstop-ob-qty]').addEventListener('input', () => {
      setQuantity(getQuantity());
    });

    modal.querySelector('[data-hotstop-ob-customize-toggle]').addEventListener('change', (event) => {
      setCustomizeEnabled(event.target.checked, true);
    });

    modal.querySelector('[data-hotstop-ob-submit]').addEventListener('click', handleAddToCart);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal?.classList.contains(STATE_OPEN)) {
        close();
      }
    });
  }

  function open(product) {
    currentProduct = product;
    selectedAddons = new Set();

    const root = ensureModal();
    const image = root.querySelector('[data-hotstop-ob-image]');
    const title = root.querySelector('[data-hotstop-ob-title]');
    const price = root.querySelector('[data-hotstop-ob-price]');
    const desc = root.querySelector('[data-hotstop-ob-description]');
    const qty = root.querySelector('[data-hotstop-ob-qty]');
    const message = root.querySelector('[data-hotstop-ob-message]');

    image.src = product.image || '';
    image.alt = product.imageAlt || product.title || '';
    title.textContent = product.title || 'Product';
    price.textContent = product.price || formatMoney(product.priceCents || 0);
    desc.textContent = product.description || '';
    desc.hidden = !product.description;

    qty.value = '1';
    message.textContent = '';
    message.classList.remove('is-error', 'is-success');

    renderAddons(product.addons || []);
    setCustomizeEnabled(false, true);
    updateTotal();

    root.classList.remove(STATE_CLOSING);
    root.classList.add(STATE_OPEN);
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add(BODY_LOCK);
    document.documentElement.dataset.hotstopB90aStatus = 'opened';

    window.setTimeout(() => {
      root.querySelector('[data-hotstop-ob-qty]')?.focus({ preventScroll: true });
    }, 80);
  }

  function close() {
    if (!modal || !modal.classList.contains(STATE_OPEN)) return;

    modal.classList.add(STATE_CLOSING);
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      modal.classList.remove(STATE_OPEN, STATE_CLOSING);
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(BODY_LOCK);
      document.documentElement.dataset.hotstopB90aStatus = 'closed';
    }, 280);
  }

  function setCustomizeEnabled(enabled, clearSelections = false) {
    if (!modal) return;

    const section = modal.querySelector('[data-hotstop-ob-addons]');
    const toggle = modal.querySelector('[data-hotstop-ob-customize-toggle]');

    if (toggle) toggle.checked = Boolean(enabled);

    if (section) {
      section.hidden = !enabled;
      section.classList.toggle('is-revealed', Boolean(enabled));
    }

    if (!enabled && clearSelections) {
      selectedAddons.clear();
      updateAddonState();
    }

    updateTotal();
    document.documentElement.dataset.hotstopB90bCustomizeEnabled = enabled ? 'true' : 'false';
  }

  function renderAddons(addons) {
    const customize = modal.querySelector('[data-hotstop-ob-customize]');
    const toggle = modal.querySelector('[data-hotstop-ob-customize-toggle]');
    const section = modal.querySelector('[data-hotstop-ob-addons]');
    const grid = modal.querySelector('[data-hotstop-ob-addon-grid]');

    grid.innerHTML = '';

    if (!addons.length) {
      customize.hidden = true;
      section.hidden = true;
      if (toggle) toggle.checked = false;
      return;
    }

    customize.hidden = false;
    section.hidden = true;
    if (toggle) toggle.checked = false;

    addons.forEach((addon, index) => {
      const card = document.createElement('article');
      card.className = 'hotstop-ob-addon';
      card.setAttribute('data-hotstop-ob-addon', '');
      card.dataset.index = String(index);
      card.role = 'button';
      card.tabIndex = 0;
      card.setAttribute('aria-pressed', 'false');

      const short = String(addon.label || '+').slice(0, 2).toUpperCase();
      const media = addon.image
        ? `<img src="${escapeHtml(addon.image)}" alt="${escapeHtml(addon.label || '')}" loading="lazy">`
        : `<span>${escapeHtml(short)}</span>`;

      card.innerHTML = `
        <span class="hotstop-ob-addon__media">${media}</span>
        <span class="hotstop-ob-addon__body">
          <span class="hotstop-ob-addon__label">${escapeHtml(addon.label || 'Add-on')}</span>
          <span class="hotstop-ob-addon__price">${escapeHtml(addon.price || (addon.type === 'free' ? 'FREE' : ''))}</span>
        </span>
        <span class="hotstop-ob-addon__check">✓</span>
      `;

      grid.appendChild(card);
    });

    updateAddonState();
  }

  function toggleAddon(index) {
    const key = String(index);
    if (selectedAddons.has(key)) selectedAddons.delete(key);
    else selectedAddons.add(key);

    updateAddonState();
    updateTotal();
  }

  function updateAddonState() {
    const cards = modal.querySelectorAll('[data-hotstop-ob-addon]');
    cards.forEach((card) => {
      const selected = selectedAddons.has(card.dataset.index);
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    modal.querySelector('[data-hotstop-ob-addon-count]').textContent = String(selectedAddons.size);
  }

  function getQuantity() {
    const input = modal.querySelector('[data-hotstop-ob-qty]');
    const value = Number.parseInt(input.value, 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function setQuantity(value) {
    const input = modal.querySelector('[data-hotstop-ob-qty]');
    const next = Math.max(1, Number.parseInt(value, 10) || 1);
    input.value = String(next);
    updateTotal();
  }

  function getSelectedAddons() {
    const toggle = modal?.querySelector('[data-hotstop-ob-customize-toggle]');
    if (toggle && !toggle.checked) return [];

    const addons = currentProduct?.addons || [];
    return Array.from(selectedAddons)
      .map((index) => addons[Number.parseInt(index, 10)])
      .filter(Boolean);
  }

  function updateTotal() {
    if (!currentProduct || !modal) return;

    const quantity = getQuantity();
    const base = Number(currentProduct.priceCents || 0);
    const addonsTotal = getSelectedAddons().reduce((sum, addon) => sum + Number(addon.priceCents || 0), 0);
    const total = (base + addonsTotal) * quantity;

    modal.querySelector('[data-hotstop-ob-total]').textContent = formatMoney(total);
  }

  async function handleAddToCart() {
    if (!currentProduct?.variantId || !modal) return;

    const button = modal.querySelector('[data-hotstop-ob-submit]');
    if (button.dataset.hotstopBusy === 'true') return;

    const quantity = getQuantity();
    const addons = getSelectedAddons();
    const groupKey = `hotstop-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    const paidAddonLineItems = addons.filter((addon) => addon.type === 'paid' && validVariantId(addon.variantId));
    const freeModifierInstructions = addons.filter((addon) => addon.type === 'free');

    const mainProperties = {
      '_hotstop_order_group': groupKey,
      '_hotstop_order_builder': 'B90F'
    };

    if (addons.length) {
      mainProperties['Tasty Add-ons'] = addons.map((addon) => addon.label).join(', ');
    }

    if (freeModifierInstructions.length) {
      // Free modifiers are preparation instructions attached to the parent meal.
      // They are intentionally not separate cart line items.
      mainProperties['Free modifiers'] = freeModifierInstructions.map((addon) => addon.label).join(', ');
      mainProperties['Customize your order'] = freeModifierInstructions.map((addon) => addon.label).join(', ');
    }

    const items = [
      {
        id: normalizeVariantId(currentProduct.variantId),
        quantity,
        properties: mainProperties
      },
      ...paidAddonLineItems.map((addon) => ({
        id: normalizeVariantId(addon.variantId),
        quantity,
        properties: {
          '_hotstop_order_group': groupKey,
          '_hotstop_parent_product': currentProduct.title || '',
          '_hotstop_addon_label': addon.label || '',
          '_hotstop_addon_type': addon.type || ''
        }
      }))
    ].filter((item) => validVariantId(item.id) && item.quantity > 0);

    if (!items.length) {
      showBuilderMessage('Unable to identify the product variant. Please refresh and try again.', 'error');
      return;
    }

    button.dataset.hotstopBusy = 'true';
    button.disabled = true;
    button.textContent = 'Adding...';
    showBuilderMessage('', '');

    document.documentElement.dataset.hotstopB90fStatus = 'adding';
    document.documentElement.dataset.hotstopB90fItemCount = String(items.length);

    try {
      const addResult = await fastAddItemsToCart(items);

      // Fast perceived success: do not block on cart.js verification.
      showBuilderMessage('Added to cart.', 'success');
      button.textContent = 'Added';
      document.documentElement.dataset.hotstopB90fStatus = 'added';

      emitFastCartEvents(addResult, items);
      refreshCartInBackground(addResult);
      tryOpenCartUI();

      window.setTimeout(() => {
        button.disabled = false;
        button.dataset.hotstopBusy = 'false';
        button.textContent = 'Add to cart';
      }, 850);
    } catch (error) {
      console.error('[HotStop B90G] Add to cart failed.', error);
      showBuilderMessage(error.message || 'Unable to add to cart. Please try again.', 'error');

      button.disabled = false;
      button.dataset.hotstopBusy = 'false';
      button.textContent = 'Add to cart';
      document.documentElement.dataset.hotstopB90fStatus = 'error';
      document.documentElement.dataset.hotstopB90fError = error.message || 'Unknown error';
    }
  }

  function validVariantId(value) {
    const id = Number(value);
    return Number.isFinite(id) && id > 0;
  }

  function normalizeVariantId(value) {
    return Number(value);
  }

  function cartRoot() {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  async function fastAddItemsToCart(items) {
    const endpoint = `${cartRoot()}cart/add.js`;
    const sections = getCartSectionIds();
    const sectionsPayload = sections.length ? sections.join(',') : '';

    // Single bulk request first. This is the fastest normal path and feels much
    // closer to Shopify's native quick-add. Including cart sections mirrors
    // Horizon's native product form, so the drawer can hydrate from the same
    // request without a second blocking cart fetch.
    try {
      const payload = { items };
      if (sectionsPayload) payload.sections = sectionsPayload;
      return await postCartAdd(endpoint, payload);
    } catch (bulkError) {
      // Fallback only on failure, not as part of the normal path.
      console.warn('[HotStop B90G] Bulk cart add failed. Trying sequential fallback.', bulkError);
      const results = [];

      for (const item of items) {
        const payload = { ...item };
        if (sectionsPayload) payload.sections = sectionsPayload;
        results.push(await postCartAdd(endpoint, payload));
      }

      return { sequential: true, results };
    }
  }

  async function postCartAdd(endpoint, payload) {
    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      const message = data?.description || data?.message || data?.status || `Cart request failed with status ${response.status}`;
      throw new Error(message);
    }

    return data;
  }

  async function getCart() {
    const response = await fetch(`${cartRoot()}cart.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(`Cart verification failed with status ${response.status}`);
    }

    return response.json();
  }

  function showBuilderMessage(text, state) {
    const message = modal?.querySelector('[data-hotstop-ob-message]');
    if (!message) return;

    message.textContent = text || '';
    message.classList.remove('is-error', 'is-success');

    if (state === 'error') message.classList.add('is-error');
    if (state === 'success') message.classList.add('is-success');
  }

  function emitFastCartEvents(addResult, items) {
    const addedQuantity = getAddedItemQuantity(items);
    const sections = extractCartSections(addResult);

    // Horizon's cart icon listens to `cart:update` and expects the same detail
    // shape used by the native product form. B90E/B90F emitted a plain custom
    // detail on `cart:update`, which Horizon interpreted as itemCount 0 and hid
    // the cart bubble. B90G keeps the fast custom events, but sends a properly
    // shaped Horizon event for the badge/drawer.
    emitHorizonCartUpdate({
      resource: addResult,
      itemCount: addedQuantity,
      sections,
      source: 'product-form-component',
      optimistic: true
    });

    const detail = {
      addResult,
      source: 'hotstop-order-builder',
      product: currentProduct,
      addons: getSelectedAddons(),
      quantity: getQuantity(),
      itemCount: addedQuantity,
      sections
    };

    [
      'cart:refresh',
      'cart:updated',
      'cart:change',
      'hotstop:cart:updated',
      'hotstop:order-builder:add'
    ].forEach((name) => {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      window.dispatchEvent(new CustomEvent(name, { detail }));
    });
  }

  async function refreshCartInBackground(addResult) {
    try {
      const cart = await getCart();
      const cartCount = Number(cart?.item_count || 0);
      const sections = extractCartSections(addResult);

      document.documentElement.dataset.hotstopCartCount = String(cartCount);
      document.documentElement.dataset.hotstopB90fCartCount = String(cartCount);
      document.documentElement.dataset.hotstopB90gCartCount = String(cartCount);

      emitHorizonCartUpdate({
        resource: cart,
        itemCount: cartCount,
        sections,
        source: 'hotstop-order-builder',
        optimistic: false
      });

      const detail = {
        cart,
        addResult,
        source: 'hotstop-order-builder',
        product: currentProduct,
        addons: getSelectedAddons(),
        quantity: getQuantity(),
        itemCount: cartCount,
        sections
      };

      ['cart:refresh', 'cart:updated', 'cart:change'].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
        document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
        window.dispatchEvent(new CustomEvent(name, { detail }));
      });
    } catch (error) {
      console.warn('[HotStop B90G] Background cart refresh failed.', error);
    }
  }

  function getAddedItemQuantity(items) {
    return items.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
  }

  function getCartSectionIds() {
    const ids = [];

    document.querySelectorAll('cart-items-component[data-section-id]').forEach((component) => {
      const sectionId = component?.dataset?.sectionId;
      if (sectionId && !ids.includes(sectionId)) ids.push(sectionId);
    });

    return ids;
  }

  function extractCartSections(addResult) {
    if (addResult?.sections && typeof addResult.sections === 'object') {
      return addResult.sections;
    }

    if (Array.isArray(addResult?.results)) {
      for (let index = addResult.results.length - 1; index >= 0; index -= 1) {
        const sections = addResult.results[index]?.sections;
        if (sections && typeof sections === 'object') return sections;
      }
    }

    return {};
  }

  function emitHorizonCartUpdate({ resource, itemCount, sections, source, optimistic }) {
    const safeItemCount = Number.isFinite(Number(itemCount)) ? Number(itemCount) : 0;
    const detail = {
      resource: resource || {},
      sourceId: 'hotstop-order-builder',
      data: {
        source,
        itemCount: safeItemCount,
        productId: String(currentProduct?.id || currentProduct?.productId || ''),
        variantId: String(currentProduct?.variantId || ''),
        sections: sections || {},
        hotstopOrderBuilder: true,
        optimistic: Boolean(optimistic)
      }
    };

    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
    document.documentElement.dispatchEvent(new CustomEvent('hotstop:cart:update-dispatched', { bubbles: true, detail }));
  }

  function tryOpenCartUI() {
    // Do this after the add request succeeds, but do not block the success state.
    window.setTimeout(() => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      const notification = document.querySelector('cart-notification');
      if (notification && typeof notification.open === 'function') {
        notification.open();
        return;
      }

      const drawerButton = document.querySelector('[data-cart-drawer-toggle], [aria-controls="CartDrawer"], button[name="cart"], a[href$="/cart"][data-drawer-trigger]');
      if (drawerButton && typeof drawerButton.click === 'function') {
        drawerButton.click();
      }
    }, 80);
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    return `₦${amount.toLocaleString('en-NG', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  window.HotStopOrderBuilder = {
    open,
    openFromHero,
    close,
  };
})();
